import { getLoginTokenRequest } from '@/services/API/auth/AuthRequestService'
import store from '@/store/store'

/**
 * @description
 * Call request for get Login token and save it in Local Storage
 *
 * @return {void}
 */
const getAndSaveLoginToken = () => {
    return new Promise((resolve, reject) => {
        let params = getLoginParams()
        if (checkRightLoginParams(params)) {
            getLoginTokenRequest(params)
                .then(response => {
                    console.log('success!')
                    store.dispatch('AuthModule/loginActions', {
                        response,
                        params,
                    }) // create local storage user data
                    resolve(response)
                })
                .catch(err => {
                    console.log('error!')
                    console.log(err)
                    store.dispatch('AuthModule/logoutActions') // delete local storage user data
                    reject(err)
                })
        } else reject(getErrorObject_IfTokenNotExistInURL())
    })
} // end function

/**
 * Get Params for Login Request
 *
 * @return {Object}
 */
function getLoginParams() {
    let moduleToken = getModuleToken_FromParams()
    let cashDeskToken = getCashDeskToken_FromParams()
    let tbkUrl = getTbkUrl_FromParams()
    return {
        module_token: moduleToken,
        cash_desk_token: cashDeskToken,
        tbk_url: tbkUrl,
    }
}

/**
 * @description
 * Get Object error when token not exist in URL
 * @return {Object}
 */
function getErrorObject_IfTokenNotExistInURL() {
    return {
        error: {
            response: {
                status: 500,
                message: 'token no existe en URL',
            },
        },
    }
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getModuleToken_FromParams = () => {
    try {
        return window.location.search
            .substr(1)
            .split('=')[1]
            .split('&cash_desk_token')[0]
    } catch (err) {
        return undefined
    }
} // end function

/**
 * @description
 * Get cash desk token from params
 * @return {void}
 */
function getCashDeskToken_FromParams() {
    try {
        return window.location.search
            .substr(1)
            .split('=')[2]
            .split('&tbk_url')[0]
    } catch (err) {
        return undefined
    }
} // end function

function getTbkUrl_FromParams() {
    try {
        if (window.location.search.substr(1).length > 3)
            return window.location.search.substr(1).split('=')[3]
        return null
    } catch (err) {
        return undefined
    }
} // end function

/**
 * @description
 * Check if Login Params is right, i.e, has login token and cash desk token
 * @param {Object} params
 */
function checkRightLoginParams(params) {
    return (
        params.module_token !== undefined &&
        params.cash_desk_token !== undefined
    )
}

export { getAndSaveLoginToken, getModuleToken_FromParams }
